import { Button, Modal, ModalProps, Stack, Textarea, useModals } from "@skailer-com/uikit";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface OptionsBulkAddModalProps extends ModalProps {
  onAdd: (titles: string[]) => void;
}

export function OptionsBulkAddModal({ onAdd, ...props }: OptionsBulkAddModalProps) {
  const { t } = useTranslation();
  const { close } = useModals();
  const [text, setText] = useState("");
  const titles = [
    ...new Set(
      text
        .split(/\r?\n/)
        .map((line) => line.trim())
        .filter(Boolean)
    ),
  ];

  const handleAdd = () => {
    if (titles.length === 0) return;

    onAdd(titles);
    close(props.id);
  };

  return (
    <Modal
      {...props}
      withCloser
      title={t("common:add_options")}
      actions={
        <Stack>
          <Button size={"lg"} onClick={handleAdd} disabled={titles.length === 0}>
            {t("plurals:add_options_count", { count: titles.length })}
          </Button>
        </Stack>
      }
    >
      <Stack gap={"sm"}>
        <Textarea
          label={t("common:enter_one_option_per_line")}
          id={`${props.id}-options`}
          autoFocus
          rows={4}
          placeholder={t("common:bulk_options_placeholder")}
          value={text}
          onChange={(event) => setText(event.target.value)}
        />
      </Stack>
    </Modal>
  );
}
